// @flow
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withI18n } from '@shopify/react-i18n';
import { routes } from 'src/routes';
import queryString from 'query-string';
import history from 'src/routes/history';
import { buildAuthURL } from 'src/helpers';
import {
  checkShopifyPaidPlan,
  isSpecialDiscount2021Expired
} from 'src/helpers/subscription-helper';

import { getSubscriptionStatus as getSubscriptionStatusV3 } from 'src/helpers/subscription-v3-helper';
import { getSubscriptionStatus } from 'src/helpers/subscription-helper';
import { Empty } from 'src/components/views/common/empty';
import { setupFullStoryUser } from 'src/integrations/fullStory';
import * as oauthAction from 'actions/oauth-actions';
import { enableOnboardingV3 } from 'src/helpers/installation-helper';
import { enableShopifyIntegration } from 'src/helpers/theme-setup-helper';
import * as commonAction from 'src/stores/actions/common-actions';
import { getCurrentPlanStatus } from 'src/helpers/subscription-v5-helper';
import { shopifyRedirect } from 'src/integrations/shopify-app-bridge/redirect';

class Oauth extends Component {
  state = {
    queries: {}
  };

  componentDidMount() {
    const { connectShopify, connectSimulator, connected, updateQueryParams } = this.props;
    if (!connected) {
      const queries = queryString.parse(this.props.location.search);
      this.setState({ queries });

      if (this.props.location.search) {
        updateQueryParams(this.props.location.search);
      }

      // If having auth0Token => access via app simulator
      const { auth0Token } = queries;
      if (auth0Token) {
        connectSimulator(queries);
      } else {
        connectShopify(queries);
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    // const queries = queryString.parse(this.props.location.search);
    if (!this.props.connected && nextProps.connected && nextProps.success) {
      // Install app in 2 cases:
      // - Not exist auth token: Store doesn't exist in our DB or store status is uninstalled
      // - Cannot detect session in shopify query params: Store exists in our DB with status active (missed hook uninstalled from shopify)

      // if (
      //   !nextProps.authToken ||
      //   (!queries.session && !queries.auth0Token && nextProps.authToken)
      // ) {
      if (!nextProps.authToken) {
        // Tenant app is not found or uninstalled, redirect to install page
        const redirectURL = buildAuthURL(nextProps.tenantId);
        console.log('Redirecting to install URL:', window.top === window.self, redirectURL);
        if (window.top === window.self) {
          // Not embedded — safe to redirect
          window.open(redirectURL, '_top');
        } else {
          // Error when not finishing oauth flow
          // const queries = queryString.parse(nextProps.location.search);
          // this.props.logApplicationConfiguration(queries);
          shopifyRedirect(redirectURL);
        }

        // Skip another process
        return;
      }

      // Handle subscription status
      // If return true, the page is redirect to subscription page, skip another process
      if (this.handleSubscriptionStatus(nextProps)) return;

      // Handle migration plan
      // This process dont allow to go to another pages
      if (this.handleMigrationPlan(nextProps)) return;

      const { status, tenantId, tenantApp, enableNewFeatureOnboarding } = nextProps;
      const { location } = this.props;

      // Set full story property
      setupFullStoryUser(tenantApp);

      switch (status) {
        case 'active': {
          const { installStatus, tenantApp } = nextProps;
          const isEnableOnboardingV3 = enableOnboardingV3(tenantApp);
          const isNewUser = enableShopifyIntegration(tenantApp);

          if (isEnableOnboardingV3) {
            // Check status and go to correct page
            // Don't check status 'theme-setup-error' because we can go any page
            switch (installStatus) {
              case 'accepted-permissions':
              case 'submitted-story-telling-1':
              case 'submitted-story-telling-2':
              case 'submitted-story-telling-3':
              case 'submitted-story-telling-4':
              case 'submitted-story-telling-5':
              case 'submitted-demographic': // For old customer not done old onboarding
              case 'selected-layout':
              case 'synced-data': {
                if (location.pathname !== routes.newInstallation.onboarding()) {
                  history.push(routes.newInstallation.onboarding());
                }
                break;
              }
              case 'submitted-kyc':
                if (isNewUser) {
                  history.push(routes.newInstallation.successInstall());
                  break;
                }
              // eslint-disable-next-line
              case 'submitted-kyc-1':
              case 'submitted-kyc-2':
              case 'submitted-kyc-3': {
                if (location.pathname !== routes.newInstallation.chooseTheme()) {
                  history.push(routes.newInstallation.chooseTheme());
                }
                break;
              }
              case 'submitted-onboarding-simplify': {
                if (location.pathname !== routes.newInstallation.selectFeature()) {
                  history.push(routes.newInstallation.selectFeature());
                }
                break;
              }
              case 'submitted-onboarding-plan': {
                if (location.pathname !== routes.newInstallation.onboardingPlan()) {
                  history.push(routes.newInstallation.onboardingPlan());
                }
                break;
              }
              case 'submitted-choose-theme': {
                if (location.pathname !== routes.newInstallation.running()) {
                  history.push(routes.newInstallation.running());
                }
                break;
              }
              case 'submitted-onboarding': {
                if (location.pathname !== routes.newInstallation.kyc()) {
                  history.push(routes.newInstallation.kyc());
                }
                break;
              }
              case 'submitted-opensurvey': {
                if (location.pathname !== routes.newInstallation.survey()) {
                  history.push(routes.newInstallation.survey());
                }
                break;
              }
              default:
                history.push(routes.dashboard.view());
                break;
            }
          } else {
            // Check status and go to correct page
            // Don't check status 'theme-setup-error' because we can go any page
            // if (!tenantId.includes('bc-dev-v2')) {
            //   switch (installStatus) {
            //     case 'accepted-permissions': {
            //       if (location.pathname !== routes.demographic.view()) {
            //         history.push(routes.demographic.view());
            //       }
            //       break;
            //     }
            //     case 'submitted-demographic': {
            //       if (location.pathname !== routes.chooseLayout.view()) {
            //         history.push(routes.chooseLayout.view());
            //       }
            //       break;
            //     }
            //     case 'selected-layout': {
            //       if (location.pathname !== routes.initializing.view()) {
            //         history.push(routes.initializing.view());
            //       }
            //       break;
            //     }
            //     case 'synced-data': {
            //       if (location.pathname !== routes.setupComplete.view()) {
            //         history.push(routes.setupComplete.view());
            //       }
            //       break;
            //     }
            //     case 'theme-setup-error': {
            //       if (location.pathname !== routes.themeSetup.view()) {
            //         history.push(routes.themeSetup.view());
            //       }
            //       break;
            //     }
            //     default:
            //       history.push(routes.dashboard.view());
            //       break;
            //   }
            // } else {
            switch (installStatus) {
              // For old customer not done old onboarding
              case 'accepted-permissions':
              case 'submitted-demographic':
              case 'selected-layout':
              case 'synced-data': {
                if (location.pathname !== routes.newInstallation.onboarding()) {
                  history.push(routes.newInstallation.onboarding());
                }
                break;
              }
              default:
                enableNewFeatureOnboarding(true, 'finished-old-onboarding', 'skip-onboard');
                history.push(routes.dashboard.view());
                break;
            }
            // }
          }
          break;
        }
        case 'disabled': {
          if (location.pathname !== routes.plan.view(tenantId)) {
            history.push(routes.plan.view(tenantId));
          }
          break;
        }
        default:
          break;
      }
    }
  }

  // Handle subscription status
  handleSubscriptionStatus = props => {
    const {
      tenantApp = {},
      history,
      installStatus,
      planName,
      subscriptionV3,
      subscriptionV4,
      subscriptionV5,
      useBoltOn
    } = props;
    const specialDiscountExpiredAt = _.get(tenantApp, 'specialDiscountExpiredAt', 0);
    const tenantId = _.get(tenantApp, 'tenantId', '');

    // Get subscription status
    const subscriptionStatus =
      subscriptionV3 || subscriptionV4
        ? getSubscriptionStatusV3(tenantApp)
        : getSubscriptionStatus(tenantApp);

    let status = _.get(subscriptionStatus, 'status', 'trial');
    if (subscriptionV5) {
      const currentPlanStatusV5 = getCurrentPlanStatus(tenantApp);
      status = currentPlanStatusV5?.status || status;
    }
    // Check dev stores
    const isPaymentPlan = checkShopifyPaidPlan(planName, tenantId);

    // Get charge_id from query params
    // Skip redirect to Plan page if status is expired or exceeded
    const queries = queryString.parse(this.props.location.search);
    const { charge_id } = queries;

    // Go to Subscription page if status is Expired, Exceeded
    const pathName = this.props.location.pathname;

    // For exceeded store subscribe by bolt-on
    if (
      (_.isEmpty(installStatus) || installStatus === 'old-customer-done-onboarding') &&
      useBoltOn &&
      !charge_id &&
      !pathName.includes('/installation') &&
      status === 'exceeded'
    ) {
      history.push(routes.subscription.plan());
      return true;
    }

    // Block access app after expired time
    const isSpecialDiscountExpired = isSpecialDiscount2021Expired(
      status,
      specialDiscountExpiredAt,
      7
    );
    if (
      (_.isEmpty(installStatus) || installStatus === 'old-customer-done-onboarding') &&
      ![
        '/plan',
        '/plan-discount',
        '/theme-setup',
        '/package',
        '/addon',
        '/package-comparison',
        '/gmv-billing-history'
      ].includes(pathName) &&
      !pathName.includes('/plan-discount-large/') &&
      !pathName.includes('/plan-large/') &&
      !pathName.includes('/package-comparison/') &&
      !pathName.includes('/shopify-integration') &&
      !pathName.includes('/installation') &&
      !useBoltOn &&
      !charge_id &&
      (status === 'expired' ||
        status === 'exceeded' ||
        status === 'regularExpired' ||
        isSpecialDiscountExpired) &&
      isPaymentPlan
    ) {
      history.push(routes.subscription.plan());

      return true;
    }

    return false;
  };

  // Handle migration to es cluster
  handleMigrationPlan = props => {
    const { tenantApp, history } = props;

    // Get cluster migration
    const { elasticsearchClusterMigrationControl = {} } = tenantApp;

    // Check cluster migration
    if (!_.isEmpty(elasticsearchClusterMigrationControl)) {
      const { lastSyncAt = 0, lastSyncDoneAt = 0 } = elasticsearchClusterMigrationControl;
      const pathName = props.location.pathname;

      if (lastSyncDoneAt < lastSyncAt && !pathName.includes('/plan-migration')) {
        history.push(routes.subscription.migration());

        return true;
      }

      return false;
    }
  };

  render() {
    const { i18n, connected, success } = this.props;
    if (connected && !success) {
      return <Empty message={i18n.translate('AdminHTML.OAuth.Empty.message')} />;
    }
    return <div></div>;
  }
}

const mapStateToProps = state => {
  const tenantApp = _.get(state.oauth, 'tenantApp', {});
  const externalInfo = _.get(tenantApp, 'externalInfo', {});

  return {
    connected: state.oauth.connected,
    success: state.oauth.connectSuccess,
    authToken: state.oauth.authToken,
    tenantId: _.get(tenantApp, 'tenantId', ''),
    useBoltOn: _.get(state.oauth, 'subscription.useBoltOn', false),
    tenantApp,
    installStatus: _.get(tenantApp, 'installStatus'),
    planName: _.get(externalInfo, 'plan_name', ''),
    status: _.get(tenantApp, 'status', ''),
    subscriptionV3: _.get(tenantApp, 'settings.subscriptionV3.settings.enable', true),
    subscriptionV4: _.get(tenantApp, 'settings.subscriptionV4.settings.enable', false)
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  connectShopify: (query: Object) => dispatch(oauthAction.connectShopify(query, ownProps.i18n)),
  connectSimulator: (query: Object) => dispatch(oauthAction.connectSimulator(query, ownProps.i18n)),
  enableNewFeatureOnboarding: (enable, source, action) =>
    dispatch(commonAction.enableNewFeatureOnboarding(enable, source, action, ownProps)),
  updateQueryParams: (query: string) => dispatch(oauthAction.updateQueryParams(query)),
});

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(Oauth));
